<template>
  <div class="page-container">
    <Sidebar />
    <div class="main-content">
      <AdminTable :apiEndpoint="'/api/admin/knowledge-updates'" :columns="columns" :filters="filters" :formFields="formFields" title="知识更新" />
    </div>
  </div>
</template>
<script>
import Sidebar from '../components/Sidebar.vue'
import AdminTable from '@/components/AdminTable.vue'
export default { name: 'KnowledgeSharesList', components: { Sidebar, AdminTable },
  data() { return {
    columns: [{ key: 'id', label: 'ID' }, { key: 'title', label: '标题' }, { key: 'created_at', label: '时间', type: 'date' }],
    filters: [], formFields: [{ key: 'title', label: '标题', type: 'text', required: true }, { key: 'description', label: '描述', type: 'textarea' }]
  } }
}
</script>
<style scoped>
.page-container { display: flex; min-height: 100vh; background: #f5f5f5; }
.main-content { flex: 1; margin-left: 260px; padding: 30px; }
</style>
